import { observer } from "mobx-react";
import { FormFieldLine } from "../../../../../../components/form-field-line/form-field-line";
import { Checkbox } from "../../../../../../components/inputs/checkbox/checkbox";

interface IProps {
    isSandbox: boolean;
    onChange: (v: boolean) => void
}

const IsSandboxField: React.FC<IProps> = observer(({ isSandbox, onChange }) => {
    return (
        <FormFieldLine
            label="Sandbox mode"
            key="is_sandbox"
            note="Pay attention, some integrations have the restrictions, limited functionality and require special credentials for this mode."
        >
            <Checkbox
                label=""
                checked={isSandbox}
                onChange={onChange}
            />
        </FormFieldLine>
    );
});

export default IsSandboxField;
